import { Autocomplete } from '@mantine/core'
import classes from './Autocomplete.module.css'

export const AutocompleteThemeKobo = Autocomplete.extend({
  classNames: classes,
})
